import axios from "axios";

import { apiDomain } from "../../store/constants";

const Consider = {
  index(payload) {
    return axios({
      url: apiDomain + "api/evaluate-layout",
      method: "GET",
      params: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  create(payload) {
    return axios({
      url: apiDomain + "api/evaluate-layout/create",
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  edit(payload) {
    return axios({
      url: apiDomain + "api/evaluate-layout/" + payload + "/edit",
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  save(payload) {
    return axios({
      url: apiDomain + "api/evaluate-layout",
      method: "POST",
      data: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  show(payload) {
    return axios({
      url: apiDomain + "api/evaluate-layout/" + payload,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  update(payload) {
    return axios({
      url: apiDomain + "api/evaluate-layout/" + payload.id,
      method: "PUT",
      data: payload.data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  delete(payload) {
    return axios({
      url: apiDomain + "api/evaluate-layout/" + payload,
      method: "DELETE",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  getEvaluateForm(id) {
    return axios({
      url: apiDomain + "api/evaluate-form/create/" + id,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  getEvaluateSummary(id) {
    return axios({
      url: apiDomain + "api/form-b/evaluated-summary/" + id,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  getEvaluateView(id) {
    return axios({
      url: apiDomain + "api/evaluate-form/" + id,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  saveEvaluateForm(payload) {
    return axios({
      url: apiDomain + "api/evaluate-form",
      method: "POST",
      data: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
};

export default Consider;
